import {
  displayBinaryImage,
  formatDisplayDate2,
  roundToTwoDecimals,
} from "Helper";

const BoxTarget = ({ item }) => {
  return (
    <div
      className="p-2 mb-0.5  w-full"
      // onClick={() => handleShowDetails(item)}
    >
      <div className={`relative`}>
        <div className="absolute inset-0 pointer-events-none">
          {/* Border sudut */}
          <div className="absolute top-[1%] z-10 w-full border-t border-red-500"></div>
          <div className="absolute top-[99%] z-10 w-full border-b border-red-500"></div>
          <div className="absolute left-[0.5%] z-10 h-full border-l border-red-500"></div>
          <div className="absolute left-[99.5%] z-10 h-full border-r border-red-500"></div>
        </div>
        <div className="absolute inset-0 pointer-events-none">
          {/* Border sudut */}
          <div className="absolute -top-[0.5%] -left-[0.2%] z-20 w-3 h-3 border-t-4 border-l-4 border-red-500"></div>
          <div className="absolute -top-[0.5%] -right-[0.2%] z-20 w-3 h-3 border-t-4 border-r-4 border-red-500"></div>
          <div className="absolute -bottom-[0.5%] -left-[0.2%] z-20 w-3 h-3 border-b-4 border-l-4 border-red-500"></div>
          <div className="absolute -bottom-[0.5%] -right-[0.2%] z-20 w-3 h-3 border-b-4 border-r-4 border-red-500"></div>
        </div>
        <div className="flex justify-between">
          <div
            key={item?.nik}
            className={`p-2 rounded-lg mb-0.5 items-center text-[10px]`}
          >
            <div className="flex flex-row gap-2 items-center pl-1 text-white w-full">
              <div
                id="gambar"
                className="flex items-center gap-2 min-w-[100px]"
              >
                <img
                  src={displayBinaryImage(item?.cropImage)}
                  alt="target"
                  className="object-cover border border-1 rounded w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]"
                />
                <img
                  src={displayBinaryImage(item?.image)}
                  alt="target"
                  className="object-cover border border-1 rounded w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]"
                />
              </div>

              <div
                id="text"
                className="flex flex-col flex-1 min-w-0 text-[10px] sm:text-xs"
              >
                <div className="capitalize font-semibold truncate">
                  {item?.fullName}
                </div>
                <div className="truncate">{item?.data?.nik}</div>
                <div className="truncate">
                  {item?.placeOfBirth +
                    ", " +
                    formatDisplayDate2(item?.dateOfBirth)}
                </div>
                <div className="truncate">
                  Similarity: {roundToTwoDecimals(item?.confidenceScore)}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxTarget;
